module.exports = __webpack_public_path__ + "img/revenue-per-hour.483824f.svg";